import ClaimableAuthenticator from "./ClaimableAuthenticator";

export default ClaimableAuthenticator;
